import React from 'react';

import PropTypes from 'prop-types';
import useFetchContentfulData from '../../hooks/useFetchContentfulData';

import SummaryTrackerPowerFleet from '../summaryTracker/powerFleetTracker';

const SummaryTrackerPowerFleetSummary = ({ orderData }) => {
  const {
    ratePlan,
    hardwarePowerFleet,
    monthlySoftwareSubscription,
    professionalServices,
    hardwareColdChainPowerFleet,
    professionalServicesColdChain
  } = orderData;

  const { data: contentfulData } =
    orderData && useFetchContentfulData('ioTFleetCompleteOrderDetails');

  return (
    <>
      {orderData && contentfulData && (
          <SummaryTrackerPowerFleet
            rateplanList={contentfulData.monthlySubscriptionColdChain}
            ratePlans={ratePlan}
            hardwarePowerFleet={hardwarePowerFleet}
            monthlySoftwareSubscription={monthlySoftwareSubscription}
            professionalServices={professionalServices}
            hardwareColdChainPowerFleet={hardwareColdChainPowerFleet}
            professionalServicesColdChain={professionalServicesColdChain}
          />
      )}
    </>
  );
};

SummaryTrackerPowerFleetSummary.propTypes = {
  orderData: PropTypes.shape({
    ratePlan: PropTypes.object,
    hardwarePowerFleet: PropTypes.object,
    monthlySoftwareSubscription: PropTypes.object,
    professionalServices: PropTypes.object,
    hardwareColdChainPowerFleet: PropTypes.object,
    professionalServicesColdChain: PropTypes.object
  }).isRequired
};

export default SummaryTrackerPowerFleetSummary;
